import { usePointCloudParams } from 'features/pointClouds/components/PointCloudContextProvider'
import { useRolodexEntries } from 'features/rolodex'
import { useEffect, useState } from 'react'
import { GeckoSiteObservation, RolodexEntryType } from 'types'

export const useObservations = () => {
  const [observations, setObservations] = useState<GeckoSiteObservation[]>([])
  const siteId = usePointCloudParams()?.siteId
  const {
    siteObservations,
    isLoading: isLoadingSiteObservations,
    forceRefresh: forecRefreshObservations,
  } = useRolodexEntries(
    siteId
      ? {
          type: [RolodexEntryType.OBSERVATION],
          tags: { [RolodexEntryType.SITE]: siteId },
          filters: [
            {
              field: 'data.alive',
              op: '=',
              value: 'true',
            },
          ],
        }
      : undefined
  )

  const { observationTickets, forceRefresh: forceRefreshTickets } =
    useRolodexEntries(
      siteId
        ? {
            type: [RolodexEntryType.OBSERVATION_TICKET],
            tags: { [RolodexEntryType.SITE]: siteId },
          }
        : undefined
    )

  const forceRefreshObservationFetchers = async () => {
    await Promise.all([forceRefreshTickets(), forecRefreshObservations()])
  }

  useEffect(() => {
    if (!isLoadingSiteObservations && siteObservations) {
      const processedObservations = [...siteObservations].map(
        (entry) => entry as unknown as GeckoSiteObservation
      )
      setObservations(processedObservations)
    }
  }, [siteObservations, isLoadingSiteObservations, siteId])

  return {
    observations,
    setObservations,
    siteObservationTickets: observationTickets,
    isLoadingSiteObservations,
    forceRefresh: forceRefreshObservationFetchers,
  }
}
